import {handleAPI, API_VERSION_ONE_ADMIN} from '../../../utils/apiUtils';
const parent = 'SETTING_'
export function insurancePlansLoad(filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurance_plans/`;
  const method = 'GET'

  return {
    type: `${parent}INSURANCE_PLANS_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function insurancePlanLoad(id, filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurance_plans/${id}`;
  const method = 'GET'

  return {
    type: `${parent}INSURANCE_PLAN_LOAD`,
    payload: handleAPI(url,filters,method)
  };
}

export function insurancePlanCreate(data, filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurance_plans`;
  const method= 'POST'
  return {
    type: `${parent}INSURANCE_PLAN_CREATE`,
    payload: handleAPI(url,filters,method, {insurance_plan: {...data}})
  }
}

export function insurancePlanUpdate(data, filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurance_plans/${data.id}`;
  const method = "PUT"
  return {
    type: `${parent}INSURANCE_PLAN_UPDATE`,
    payload: handleAPI(url,filters,method, {insurance_plan: {...data}})
  }
}

export function insurancePlanDelete(id, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurance_plans/${id}`;
  const method = 'DELETE';

  return {
    type: `${parent}INSURANCE_PLAN_DELETE`,
    payload: new Promise((resolve, reject) => {
      handleAPI(url, filters, method)
        .then(response => {
          resolve({ id: id, ...response });
        })
        .catch(err => {
          reject(err);
        });
    })
  };
}

export function insurancePlanEdit(id, insuranceType) {
  return {
    type: `${parent}INSURANCE_PLAN_EDIT`,
    id,
    insuranceType,
  };
}

export function insurancePlanEditCancel() {
  return {
    type: `${parent}INSURANCE_PLAN_EDIT_CANCEL`
  };
}

export function insurancePlansListReset() {
  return {
    type: `${parent}INSURANCE_PLANS_LIST_RESET`
  };
}

export function insurancePlanAddFromMasterList(data) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurance_plans/add_from_master_list`;
  const method = 'PATCH';

  return {
    type: `${parent}INSURANCE_PLAN_ADD_FROM_MASTER_LIST`,
    payload: handleAPI(url, {}, method, data)
  };
}